module.exports = __webpack_public_path__ + "static/img/kefu_icon.9a78e6a0.png";